var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBannerPaleGreenDesktop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1145,
    height: 250,
    viewBox: "0 0 1145 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_552_7260)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1145,
    height: 250,
    fill: "#B5DDD6"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_552_7260)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M179.666 47C219.357 47 251.532 14.7645 251.532 -25C251.532 -64.7645 219.357 -97 179.666 -97C139.975 -97 107.8 -64.7645 107.8 -25C107.8 14.7645 139.975 47 179.666 47ZM179.666 71C232.587 71 275.488 28.0193 275.488 -25C275.488 -78.0193 232.587 -121 179.666 -121C126.745 -121 83.8442 -78.0193 83.8442 -25C83.8442 28.0193 126.745 71 179.666 71Z",
    fill: "#CEFFF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.3 166.214C139.356 169.074 137.66 175.403 140.511 180.352L146.325 190.44C149.177 195.388 155.496 197.082 160.44 194.222L170.493 188.407C175.436 185.548 177.132 179.218 174.281 174.27L168.467 164.182C165.616 159.233 159.296 157.54 154.352 160.4L144.3 166.214Z",
    fill: "#B5F6EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.298 68.6C260.864 66.8432 255.039 69.8258 253.288 75.262L245.12 100.621C243.369 106.057 246.355 111.889 251.789 113.645L277.072 121.819C282.506 123.576 288.331 120.593 290.082 115.157L298.25 89.7977C300.001 84.3616 297.015 78.5305 291.581 76.7736L266.298 68.6Z",
    fill: "#B5F6EC"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_552_7260"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1145,
    height: 250,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_552_7260"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 359.331,
    height: 300,
    fill: "white",
    transform: "translate(0 -25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerPaleGreenDesktop);
export default __webpack_public_path__ + "static/media/banner-pale-green-desktop.e5a683880b96343c66b11b040eaefd79.svg";
export { ForwardRef as ReactComponent };